import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import { IdentifyProps } from "@utils/analytics.types";
import config from "@utils/config";
import { captureException } from "@utils/captureException";
import { capabilities } from "../capabilities";

let customerio: AnalyticsBrowser | null = null;

const isCustomerIoAllowed = () => capabilities.allowed("customerio");

export const initialize = () => {
  if (!isCustomerIoAllowed()) {
    console.log("::customerio web:: disabled in preview");
    return;
  }

  try {
    customerio = AnalyticsBrowser.load(
      {
        cdnURL: "https://cdp-eu.customer.io",
        writeKey: config.CUSTOMERIO.API_KEY,
      },
      {
        integrations: {
          "Customer.io In-App Plugin": {
            siteId: config.CUSTOMERIO.SITE_ID,
          },
        },
      },
    );
  } catch (error) {
    captureException(error, {
      channel: "breadcrumb",
      area: "messaging",
      operation: "customerio-web-initialize",
    });
  }
};

export const identify = ({
  userId,
  email,
  countryCode,
  createdAt,
  plan_name,
}: IdentifyProps) => {
  if (!isCustomerIoAllowed()) {
    return;
  }

  if (!customerio) {
    console.error(`::identify - CustomerIO not initialized`);
    return;
  }

  customerio
    .identify(userId, {
      email,
      countryCode,
      ...(createdAt === undefined
        ? {}
        : { createdAt: new Date(createdAt * 1000) }),
      plan_name,
    })
    .catch((error) => {
      captureException(error, {
        channel: "breadcrumb",
        area: "messaging",
        operation: "customerio-web-identify",
      });
    });
};
